// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2UACZ","rootSmall":"AddTileButton_rootSmall__NLawt"};